<template>
  <div class="pdpa-wrapper text-center py-5 px-3 px-md-5">
    <h6 class="pdpa-title mb-4">{{ headerText }}</h6>

    <CRow class="justify-content-center">
      <CCol cols="12" md="8">
        <div v-if="pdpaImages.length">
          <img
              v-for="(img, index) in pdpaImages"
              :key="index"
              :src="getFullImagePath(img)"
              class="img-fluid rounded shadow pdpa-image mb-2"
              alt="PDPA Banner"
          />
        </div>
      </CCol>
    </CRow>

    <CRow class="justify-content-center mt-4">
      <CCol cols="12" md="8" class="d-flex justify-content-center">
        <label class="custom-radio-label d-flex align-items-center">
          <input
              type="checkbox"
              class="custom-radio-input mr-2"
              v-model="agreeChecked"
              @change="onCheckboxChange"
          />
          <span class="custom-radio-check mr-2"></span>
          <span class="radio-text">{{ radioLabel }}</span>
        </label>
      </CCol>
    </CRow>

    <CRow class="justify-content-center mt-4" v-if="showSubmit">
      <CCol cols="auto">
        <button
            :disabled="!agreeChecked"
            :class="['submit-btn btn px-5 py-2', agreeChecked ? 'active' : '']"
            id="submitBtn"
            @click="onSubmit"
        >
          Submit
        </button>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import api from '@/service/api'
import '@/assets/css/pdpa.css'

export default {
  name: 'PdpaConsent',

  data() {
    return {
      headerText: '',
      radioLabel: '',
      pdpaImages: [], // ใช้ array
      swalMessage: '',
      agreeChecked: false,
      showSubmit: false,
      pdpaKey: '',
      checkboxKey: ''
    }
  },

  mounted() {
    this.updateKeysFromType()
    this.fetchPdpaData()
  },

  methods: {
    updateKeysFromType() {
      const type = this.$route.params.type
      this.pdpaKey = `pdpa_${type}`
      this.checkboxKey = `pdpa_checkbox_state_${type}`
    },

    async fetchPdpaData() {
      try {
        const res = await api.pdpa('get')
        const data = res.data.data?.[0]
        if (data) {
          this.headerText = data.pdpa_header
          this.radioLabel = data.redio_label
          this.swalMessage = data.massage
          this.pdpaImages = Array.isArray(data.pdpa_img) ? data.pdpa_img : []
        }

        this.restoreCheckboxState()
      } catch (err) {
        console.error(err)
        this.headerText = 'PDPA'
        this.radioLabel = 'I agree to Permission to collect personal data'
        this.swalMessage = 'By checking this box, you agree to the terms regarding personal data collection.'
      }
    },

    restoreCheckboxState() {
      const isChecked = localStorage.getItem(this.checkboxKey) === 'true'
      const isSubmitted = localStorage.getItem(this.pdpaKey) === 'true'
      this.agreeChecked = isSubmitted || isChecked
      this.showSubmit = isSubmitted || isChecked
    },

    onCheckboxChange() {
      localStorage.setItem(this.checkboxKey, this.agreeChecked.toString())

      if (this.agreeChecked) {
        Swal.fire({
          text: this.swalMessage,
          confirmButtonText: 'OK',
        }).then(() => {
          this.showSubmit = true
        })
      } else {
        this.showSubmit = false
      }
    },

    onSubmit() {
      if (this.agreeChecked) {
        localStorage.setItem(this.pdpaKey, 'true')
        localStorage.removeItem(this.checkboxKey)

        const type = this.$route.params.type
        if (type === 'president') {
          this.$router.push('/condition/condition_union')
        } else if (type === 'school') {
          this.$router.push('/condition/condition_school')
        } else if (type === 'normal') {
          this.$router.push('/condition/condition_normal')
        } else if (type === 'assosiation') {
          this.$router.push('/condition/condition_assosiation')
        } else {
          this.$router.push('/')
        }
      }
    },

    getFullImagePath(path) {
      // return path ? `http://127.0.0.1:8030${path}` : ''
       return path ? `https://election-su.mfu.ac.th${path}` : ''
    }
  }
}
</script>
